<template>
  <div class="question-page finder-page" :id="q_id">
    <h2 class="title" ><span v-html="page.question"></span><img v-if="page.emojis" :src="page.emojis" class="emojis" alt=""><span v-if="page.emojis">?</span></h2>
    <div :class="'length'+page.answers.length" class="cards">
      <answer-card v-for="(answer, i) in page.answers"
      :key="String(q_id) + '_' + String(i)"
      :answer="answer"
      @answer="animateAnswer"
      :aindex="i"
      ></answer-card>
    </div>
  </div>
</template>

<script>
import AnswerCard from "./AnswerCard";
import anime from 'animejs'

  export default {
    name: "QuestionPage",
    components: {
      AnswerCard
    },
    props: {
      page: {
        type: Object,
        required: true
      },
      q_id: {
        type: [Number, String],
        required: false
      },
    },
    methods: {
      animateAnswer(i) {
        //console.log("hello");
        const self = this;

        // Animate Card
        const selectedCard = document.getElementById("ac-" + i);
        const otherCards = document.querySelectorAll(".question-page .answer-card:not(#ac-" + i + ")");
        const answerTitle = document.querySelectorAll('.answer-popup .title');
        var cards = document.querySelectorAll(".cards");

        const timeline = anime.timeline();

        timeline
        // Other Cards fade down
        .add({
          targets: otherCards,
          opacity: 0.3,
          duration: 700,
          offset: '0',
          easing: 'easeOutExpo',
          elasticity: 0
        })
        // all cards fade-out
        .add({
          targets: [cards, '.question-page > .title'],
          opacity: 0,
          duration: 500,
          delay: 0,
          easing: 'easeOutExpo',
          elasticity: 0,
          complete() {
            self.goNext(i);
          }
        })
        // Next Question & Cards Fade In
        .add({
          targets: [cards, '.question-page > .title'],
          opacity: 1,
          duration: 800,
          delay: 300
        })

      },
      goNext(answer_index) {
        let answer = this.page.answers[answer_index];

        this.$emit("answer",
          this.q_id,
          answer_index,
          answer
        );
      },
      goPrev() {
        this.$emit("answer", Number(this.q_id) - 1);
      }
    },
  }
</script>

<style lang="scss">
h2.title {
  font-size: 1.25em;
  font-family: $sans_serif;
  font-weight: 600;
  text-transform: uppercase;
  color: black;
  margin: 1em auto;

  @media all and (max-width: 374px) {
    font-size: 1.0em;
  }

  img.emojis{
    height: 20px;
    position: relative;
    top: 2px;
    margin-right: 4px;
    margin-left: 4px;
  }
}

.question-page {
  // display: flex;
  // flex-direction: column;
  // justify-content:space-around;
  display: flex;
  flex-direction:column;
  overflow-y: auto;
  // max-height: 700px;
  // @media all and (min-width: 768px) {
  //   max-height: 400px;
  // }

  .answer-popup {
    position: relative;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%,-50%);

    // width: 50%;
    flex-grow: 1;

    .group {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    svg {
      width: 25%;
    }

    .title, .success {
      opacity: 0;

      color: $success-color;
      font-family: $sans-serif;
    }
  }
}

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // align-items:stretch;
  // margin: 0 5px;
  //opacity: 0;
  overflow: hidden;
  //background-color: red;
  flex:1;
  padding-bottom: 10px;

  @media all and (max-width: 374px) {
    max-height: 368px;
  }

}
</style>